"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableContext = void 0;
const react_1 = __importDefault(require("react"));
const TableContext = react_1.default.createContext(null);
exports.TableContext = TableContext;
TableContext.displayName = 'TableContext';
